import axios from 'axios';
import API_BASE_URL from '../config/apiConfig';

// Configuration de base de l'API centralisée

// Instance axios avec configuration de base
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: false,
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les réponses et les erreurs
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const requestUrl = error.config?.url || '';
      const isPublicProfessionals = requestUrl.startsWith('/users/professionals');
      const isEmailVerification = requestUrl.includes('/auth/verify-email');

      if (!isPublicProfessionals && !isEmailVerification && currentPath !== '/login' && currentPath !== '/register') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    
    // Retourner l'erreur formatée
    const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || 'Une erreur est survenue';
    return Promise.reject(new Error(errorMessage));
  }
);

export default api;